module.exports = __webpack_public_path__ + "img/young-test.8855de39.png";